import KultifyLogo from "./images/kultify_wheel.png";

const FullscreenLoader = () => {
	return (
		<div className="flex w-screen h-screen justify-center items-center bg-background">
			<img src={KultifyLogo} alt="" className="w-32 h-32 animate-fade-in" />
		</div>
	);
};

export default FullscreenLoader;
